import { render, staticRenderFns } from "./SidePanel2.vue?vue&type=template&id=e50af518&scoped=true&"
import script from "./SidePanel2.vue?vue&type=script&lang=ts&"
export * from "./SidePanel2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50af518",
  null
  
)

export default component.exports